import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Welcome to thePsychologyTutor!
        </p>
        <p>Contact me at contact@thePsychologyTutor.uk</p>
      </header>
    </div>
  );
}

export default App;
